<div class="aig-newPassword p-flexcc u-height-vh-100">
  <div class="u-border u-radius-2 u-p-7 aig-newPassword__wrap">
    <div class="p-flexcc u-dir-col">
      <img class="" src="./assets/images/logos/logo.svg" alt="logo_aig" loading="lazy" />

      <p class="u-fs-40 u-color-primary1 u-my-4">Nueva contraseña</p>
    </div>

    <form class="row" [formGroup]="passwordForm">
      <div class="col-12">
        <div class="e-field">
          <label for="password-field" class="e-field__label">
            Nueva contraseña
          </label>
          <div class="p-flexcc">
            <input [type]="showPasswordNew ? 'text' : 'password'" class="e-field__input u-ps-2 u-py-1"
              id="password-field" formControlName="passwordnew" autocomplete="no" />
            <button class="u-pos-absolute u-end-0 u-cursor-pointer u-bg-transparent u-border-none" id="viewPassword"
              (click)="showPasswordNew = !showPasswordNew">
              <i [ngClass]="showPasswordNew ? 'icon-eye-close' : 'icon-eye-open' "
                class="u-color-secondary1 u-mx-def u-fs-18"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 u-mb-4">
        

        <ng-container *ngIf="!passwordValid; else successMessage">
          <ul>
            <li *ngFor="let requirement of passwordRequirements" class="u-fs-18 u-color-secondary1">
              {{ requirement }}
            </li>
          </ul>
        </ng-container>
        <ng-template #successMessage>
          <p class="u-fs-18 u-color-success">La contraseña cumple con los requisitos</p>
        </ng-template>
       
      </div>

      <div class="col-12">
        <div class="e-field">
          <label for="password-field" class="e-field__label">
            Confirmar contraseña
          </label>
          <div class="p-flexcc">
            <input [type]="showPasswordRepeat ? 'text' : 'password'" class="e-field__input u-ps-2 u-py-1"
              id="password-field" formControlName="passwordconfirm" autocomplete="no" />
            <button class="u-pos-absolute u-end-0 u-cursor-pointer u-bg-transparent u-border-none" id="viewPassword"
              (click)="showPasswordRepeat = !showPasswordRepeat">
              <i [ngClass]="showPasswordRepeat ? 'icon-eye-close' : 'icon-eye-open' "
                class="u-color-secondary1 u-mx-def u-fs-18"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-12">
        <p *ngIf="passwordForm.get('passwordconfirm')?.touched" class="u-color-warning-error u-pb-def u-fs-18">
          {{ passwordsMatch ? '' : 'Las contraseñas no coinciden ' }}
        </p>
      </div>

  
      <div class="col-12 p-flexcc">
        <button id="session-btn" class="e-btn--primary u-fw-600 u-cursor-pointer aig-newPassword__btn" type="submit" (click)="Send()" >
          Enviar
        </button>
      </div>
    </form>

  </div>

  @if(visibleMessageModal){
    <aig-modal-message (hideModal)="CloseModal()"></aig-modal-message>
    }